import { MessageCircle } from 'lucide-react';

export const FloatingWhatsApp = ({ handleWhatsAppClick }) => (
<button
        data-testid="floating-whatsapp-button"
        onClick={handleWhatsAppClick}
        className="fixed bottom-8 right-8 z-50 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white p-5 rounded-full shadow-2xl shadow-green-500/60 transition-all duration-300 transform hover:scale-110 animate-pulse"
        aria-label="Contact WhatsApp"
      >
        <MessageCircle className="w-8 h-8" />
      </button>
);
